// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ChangeClientTypeResource extends Resource {
    basePath: string = 'clients/change-client-type/';
}
